import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, IconButton } from '@mui/material';
import { closeSnackbar, useSnackbar } from 'notistack';
import { createElement, Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const useNewVersionSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  useEffect(() => {
    const handleSwUpdated = () => {
      enqueueSnackbar(
        createElement(
          'span',
          { style: { fontWeight: 600, color: '#fff', fontSize: '0.875rem' } },
          t('common:commonValues.newVersionAvailable')
        ),
        {
          variant: 'default',
          persist: true,
          preventDuplicate: true,
          anchorOrigin: { vertical: 'top', horizontal: 'right' },
          style: { backgroundColor: '#b45309' },
          action: (snackbarId) =>
            createElement(
              Fragment,
              null,
              createElement(
                Button,
                {
                  variant: 'contained',
                  size: 'small',
                  style: {
                    backgroundColor: '#fff',
                    color: '#451a03',
                    fontWeight: 700,
                    marginRight: '4px',
                  },
                  startIcon: createElement(RefreshIcon),
                  onClick: () => {
                    closeSnackbar(snackbarId);
                    window.location.reload();
                  },
                },
                t('common:commonValues.reload')
              ),
              createElement(
                IconButton,
                {
                  size: 'small',
                  style: { color: '#fff' },
                  onClick: () => closeSnackbar(snackbarId),
                },
                createElement(CloseIcon, { fontSize: 'small' })
              )
            ),
        }
      );
    };

    window.addEventListener('sw-updated', handleSwUpdated);
    return () => window.removeEventListener('sw-updated', handleSwUpdated);
  }, [enqueueSnackbar, t]);
};
